import React from "react";
import { formatPrice } from "../data/properties";
import { MapPin } from "lucide-react";

export const PropertyCard = ({ p, featured = false }) => {
    return (
        <article
            className="group relative overflow-hidden border border-white/10 hover:border-brand-gold/50 transition-all duration-700 bg-brand-onyx"
            data-testid={`property-card-${p.id}`}
        >
            <div className="relative aspect-[4/3] overflow-hidden">
                <img
                    src={p.image}
                    alt={p.name}
                    className="img-zoom w-full h-full object-cover"
                    loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
                <div className="absolute top-4 left-4 text-[0.62rem] tracking-[0.35em] uppercase text-brand-gold border border-brand-gold/60 bg-black/40 backdrop-blur px-3 py-1.5">
                    {p.tag}
                </div>
                <div className="absolute bottom-5 left-5 right-5">
                    <div className="flex items-end justify-between gap-4">
                        <div>
                            <h3 className="font-serif-editorial text-brand-champagne text-2xl md:text-3xl leading-tight">
                                {p.name}
                            </h3>
                            <p className="mt-1 text-xs tracking-wider text-brand-silver/80 flex items-center gap-1.5">
                                <MapPin size={12} className="text-brand-gold" /> {p.location}
                            </p>
                        </div>
                        <div className="text-right">
                            <div className="text-brand-silver text-lg md:text-xl font-light">
                                {formatPrice(p.price)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="p-6 md:p-7">
                <p className="text-sm text-brand-silver/70 leading-relaxed line-clamp-3">
                    {p.description}
                </p>
                <div className="mt-5 flex items-center gap-5 text-[0.7rem] tracking-[0.25em] uppercase text-brand-silver/60">
                    {p.beds != null && (
                        <span><span className="text-brand-gold">{p.beds}</span> Beds</span>
                    )}
                    {p.baths != null && (
                        <>
                            <span className="w-1 h-1 bg-brand-gold/60 rotate-45" />
                            <span><span className="text-brand-gold">{p.baths}</span> Baths</span>
                        </>
                    )}
                    <span className="w-1 h-1 bg-brand-gold/60 rotate-45" />
                    <span><span className="text-brand-gold">{p.sqft.toLocaleString()}</span> SqFt</span>
                </div>
            </div>
        </article>
    );
};

export default PropertyCard;
